module.exports = "/work-site/img/lifting.256ac6d0.png";